module.exports = __webpack_public_path__ + "img/basic-mic.6942ac07.svg";